import { ReactElement } from 'react';
import MagnifyingGlass from '../../../components/svg/MagnifyingGlass';

type KeywordSearchProps = {
  keywords: string;
  search: () => void;
  hasSearchChanged: boolean;
  setKeywords: (arg: string) => void;
  setSearchChanged: (arg: boolean) => void;
  placeholder?: string;
};

// TODO: Move to shared location to be referenced by bills and regs data
const KeywordSearch = (props: KeywordSearchProps): ReactElement => {
  const {
    keywords,
    search,
    hasSearchChanged,
    setKeywords,
    setSearchChanged,
    placeholder,
  } = props;

  const handleKeywordsChange = (updatedKeywords: string): void => {
    setKeywords(updatedKeywords);
    setSearchChanged(true);
  };

  return (
    <div className="keyword-search-field">
      <div className="row flex-nowrap">
        <div className="search-icon">
          <MagnifyingGlass height="20" width="21" />
        </div>
        <input
          id="bill-search-input"
          onChange={(e) => handleKeywordsChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && hasSearchChanged) search();
          }}
          placeholder={placeholder ?? undefined}
          type="text"
          value={keywords || ''}
        />
      </div>
    </div>
  );
};

export default KeywordSearch;
